import * as React from 'react';
import JobQuoteAcceptedEvent, {JobQuoteAcceptedEventData} from "../../../../model/job/event/JobQuoteAcceptedEvent";
import {RouteComponentProps, withRouter} from "react-router";
import CommonStreamItem, {StreamItemAction} from "../../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import QuoteDetailsModal from "../../../lead/quote/QuoteDetailsModal";
import Routes from "../../../../navigation/route/Route";


interface ComponentProps {
	/**
	 * Job activity to display.
	 */
	activity: JobQuoteAcceptedEvent;
}

interface State {
	/**
	 * Indicate if quote details modal is visible.
	 */
	detailsVisible: boolean;
}

type Props = ComponentProps & RouteComponentProps<{}>;

class JobActivityQuoteItemWithAction extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {detailsVisible: false};
	}

	render() {
		let actions: StreamItemAction[] = [
			StreamItemAction.new("Show details", () => this.setState({detailsVisible: true})),
			StreamItemAction.new("Quote Summary", this.redirectToQuoteSummary),
		];
		const quoteId = (this.props.activity.data as JobQuoteAcceptedEventData).quoteId;
		return (
			<React.Fragment>
				<CommonStreamItem event={this.props.activity} actions={actions}/>
				{this.state.detailsVisible &&
				<QuoteDetailsModal onClose={() => this.setState({detailsVisible: false})}
								   quoteId={quoteId}
								   onReviewQuoteClick={this.redirectToQuoteSummary}/>}
			</React.Fragment>
		);
	}

	redirectToQuoteSummary = () => this.props.history.push(
		Routes.JobQuoteView(this.props.activity.referenceNumber, this.props.activity.data.quoteId));
}

export default withRouter<ComponentProps>(JobActivityQuoteItemWithAction)
